import dayjs from 'dayjs';

/**
 * Gets the first and last day of the previous month in YYYY-MM-DD format.
 *
 * @return {{ firstDay: string, lastDay: string }} Object containing first and last day strings
 */
const getLastMonthDateRange = (): { firstDay: string; lastDay: string } => {
  const lastMonth = dayjs().subtract(1, 'month');
  const firstDay = lastMonth.startOf('month').format('YYYY-MM-DD');
  const lastDay = lastMonth.endOf('month').format('YYYY-MM-DD');

  return { firstDay, lastDay };
};

export { getLastMonthDateRange };
